import { render } from "./unifiChild.vue?vue&type=template&id=a4c65862&scoped=true"
import script from "./unifiChild.vue?vue&type=script&lang=js"
export * from "./unifiChild.vue?vue&type=script&lang=js"

import "./unifiChild.vue?vue&type=style&index=0&id=a4c65862&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4c65862"]])

export default __exports__